const conflictTypes = [
  { icon: 'ri-chat-quote-line', title: 'Рабочее разногласие', desc: 'Сотрудники по-разному видят способ решения задачи. Это нормально, если обсуждение остаётся в рамках работы и не переходит на личности.' },
  { icon: 'ri-message-3-line', title: 'Конструктивная дискуссия', desc: 'Спор о лучшем решении, в котором стороны слышат друг друга и ищут оптимальный вариант для дела, а не «победу» любой ценой.' },
  { icon: 'ri-emotion-unhappy-line', title: 'Межличностный конфликт', desc: 'Напряжение между конкретными людьми из-за стиля общения, ценностей или личных обид. Часто маскируется под рабочую проблему.' },
  { icon: 'ri-scales-3-line', title: 'Конфликт интересов', desc: 'Стороны преследуют разные интересы: например, один хочет быстрее, другой — качественнее, а ресурсы ограничены.' },
  { icon: 'ri-user-location-line', title: 'Спор об ответственности', desc: 'Каждый считает, что задачу должен выполнять другой, либо оба претендуют на одну и ту же зону ответственности.' },
  { icon: 'ri-user-search-line', title: 'Сотрудник и руководитель', desc: 'Несогласие с требованиями, решениями или стилем руководства. Требует отдельного и аккуратного управленческого разговора.' },
  { icon: 'ri-building-2-line', title: 'Конфликт подразделений', desc: 'Отделы оптимизируют собственный результат в ущерб общему: продажи против производства, маркетинг против продаж и так далее.' },
];

export default function WhatIsConflict() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Конфликт — это не всегда проблема
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Конфликт возникает, когда сталкиваются интересы, цели, позиции, ожидания, способы работы или представления сотрудников о правильном результате
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {conflictTypes.map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Задача руководителя — не сделать так, чтобы люди никогда не спорили, а создать условия, при которых разногласия не разрушают работу и переводятся в решение. Конфликт становится проблемой не тогда, когда он возникает, а когда им никто не управляет.
          </p>
        </div>
      </div>
    </section>
  );
}